import React, { useEffect, useState } from 'react';
import { Card, Table, Tag, Space, Button, message, Checkbox, Input } from 'antd';
import { getRecentOrders, createCheckoutPayment, createCheckoutSubscription } from '../utils/api';
import { customFetch } from '../utils/api';

const GuduSalesPage: React.FC = () => {
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isTestMode, setIsTestMode] = useState(true);
  const [productId, setProductId] = useState('79980');
  const [productName, setProductName] = useState('gudu omni sql');

  useEffect(() => {
    const fetchOrders = async () => {
      setLoading(true);
      try {
        const resp = await getRecentOrders({ page: 1 });
        if (resp.ok) {
          const data = await resp.json();
          setOrders(data.results || []);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  return (
    <div style={{ padding: 16 }}>
      <Card title="Gudu Sales - Orders" extra={
        <Space>
          <Input addonBefore="Product ID" value={productId} onChange={(e) => setProductId(e.target.value)} style={{ width: 200 }} />
          <Input addonBefore="Product Name" value={productName} onChange={(e) => setProductName(e.target.value)} style={{ width: 300 }} />
          <Checkbox checked={isTestMode} onChange={(e) => setIsTestMode(e.target.checked)}>Test mode</Checkbox>
          <Button type="primary" onClick={async () => {
            try {
              const resp = await createCheckoutPayment({ 
                price: isTestMode ? 'price_1O7I2qDca5TYlnXWxnfYMhFX' : 'price_1SIPodDca5TYlnXWHxf8DT1Q',
                product_id: productId,
                product_name: productName,
              });
              const data = await resp.json();
              if (resp.ok && data.url) {
                window.location.href = data.url;
              } else {
                message.error(data.detail || 'Failed to create checkout session');
              }
            } catch (e) {
              message.error('Failed to create payment session');
            }
          }}>One Time Payment</Button>
          <Button onClick={async () => {
            try {
              const resp = await createCheckoutSubscription({ 
                price: isTestMode ? 'price_1LOZUoDca5TYlnXWT5CViUAu' : 'price_1SCHedDca5TYlnXW9ueZYFtv',
                product_id: productId,
                product_name: productName,
              });
              const data = await resp.json();
              if (resp.ok && data.url) {
                window.location.href = data.url;
              } else {
                message.error(data.detail || 'Failed to create subscription session');
              }
            } catch (e) {
              message.error('Failed to create subscription session');
            }
          }}>Subscription</Button>
          <Button onClick={async () => {
            try {
              const resp = await customFetch('/api/crm/checkout/simulate-renew/', { method: 'POST' });
              const data = await resp.json();
              if (resp.ok) {
                message.success(`Renew simulated: order ${data.orderid}`);
                // refresh orders
                const r = await getRecentOrders({ page: 1 });
                if (r.ok) {
                  const d = await r.json();
                  setOrders(d.results || []);
                }
              } else {
                message.error(data.detail || 'Failed to simulate renewal');
              }
            } catch (e) {
              message.error('Failed to simulate renewal');
            }
          }}>Renew</Button>
        </Space>
      }>
        <Table
          size="middle"
          loading={loading}
          dataSource={orders}
          rowKey={(r) => `${r.id}`}
          columns={[
            { title: 'Date', dataIndex: 'orderdate', key: 'orderdate' },
            { title: 'Order ID', dataIndex: 'orderid', key: 'orderid' },
            { title: 'Email', dataIndex: 'email', key: 'email' },
            { title: 'Product', dataIndex: 'product_id', key: 'product_id' },
            { title: 'Qty', dataIndex: 'qty', key: 'qty', width: 80 },
            { title: 'Total', dataIndex: 'total', key: 'total', render: (v) => `$${v}` },
            { title: 'Type', dataIndex: 'order_type', key: 'order_type', render: (t) => <Tag>{t}</Tag> },
          ]}
        />
      </Card>
    </div>
  );
};

export default GuduSalesPage;


